import { StyleSheet } from 'react-native';

export const createStyles = () => StyleSheet.create({
  container: {
    flex: 1
  },
  scrollContent: {
    padding: 20
  },
  avatarSection: {
    alignItems: 'center',
    marginBottom: 30,
    marginTop: 20
  },
  avatar: {
    width: 100,
    height: 100,
    borderRadius: 50,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 15
  },
  avatarImage: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 15
  },
  avatarText: {
    fontSize: 40,
    fontWeight: 'bold',
    color: '#fff'
  },
  changePhotoBtn: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 20,
    minWidth: 140,
    alignItems: 'center',
    borderWidth: 1
  },
  changePhotoBtnContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6
  },
  changePhotoText: {
    fontSize: 14,
    fontWeight: '600'
  },
  section: {
    marginBottom: 20,
    padding: 15,
    borderRadius: 12,
    borderWidth: 1
  },
  label: {
    fontSize: 12,
    fontWeight: '600',
    marginBottom: 8,
    textTransform: 'uppercase',
    letterSpacing: 0.5
  },
  input: {
    fontSize: 16,
    padding: 12,
    borderRadius: 8,
    borderWidth: 1
  },
  textArea: {
    fontSize: 16,
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    minHeight: 100,
    textAlignVertical: 'top'
  },
  helpText: {
    fontSize: 12,
    marginTop: 5
  },
  charCount: {
    fontSize: 12,
    textAlign: 'right',
    marginTop: 5
  },
  saveBtn: {
    padding: 16,
    borderRadius: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  saveBtnContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  },
  saveBtnText: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  cancelBtn: {
    padding: 16,
    borderRadius: 10,
    alignItems: 'center',
    borderWidth: 1
  },
  cancelBtnContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  },
  cancelBtnText: {
    fontSize: 16,
    fontWeight: '600'
  },
});
